import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const ShiftFormHeader = observer(({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = (isEdit ? t('edit', 'Edit') : t('addNew', 'Add new')) + ' ' + t('shift', 'Shift')

  const breadCrumbs: BreadcrumpItem[] = useMemo(() => {
    return [
      { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
      {
        label: t('shifts', 'Shifts'),
        route: PATHS.masterData.shift.url,
      },
      {
        label: action,
      },
    ]
  }, [t, action, navigate])

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-shift-btn'
            onClick={() => navigate(PATHS.masterData.shift.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='shift-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
